import { COLUMN_FIXED_ADDRESS, COLUMN_IP_ADDRESS, COLUMN_NAME, COLUMN_READERS_COUNT, COLUMN_SITE, COLUMN_TYPE, COLUMN_QUEUE } from "../../constants/column-types";
import { FILTER_SITES } from "../../constants/filter-types";
import { TableColumn } from "../table/TableColumn";

const ControllerColumns : TableColumn[] = [
    {
        heading: "Name",
        accessor: "name",
        isNumeric: false,
        id: 0,
        sortByName: "devName",
        sortDirection: "asc",
        active: true,
        translationKey: "name",
        isDefault: true,
        columnId: COLUMN_NAME,
    },
    {
        heading: "Fixed Address",
        accessor: "fixedAddress",
        isNumeric: false,
        id: 1,
        sortByName: "devFixedAddr",
        sortDirection: "asc",
        active: true,
        translationKey: "fixedAddress",
        columnId: COLUMN_FIXED_ADDRESS,
    },
    {
        heading: "IP Address",
        accessor: "ipAddress",
        isNumeric: false,
        id: 2,
        sortByName: "devIpAddress",
        sortDirection: "asc",
        active: true,
        translationKey: "ipAddress",
        columnId: COLUMN_IP_ADDRESS,
    },
    {
        heading: "Type",
        accessor: "type",
        isNumeric: false,
        id: 3,
        sortByName: "unitType.trnName",
        sortDirection: "asc",
        active: true,
        translationKey: "type",
        columnId: COLUMN_TYPE,
    },
    {
        heading: "Site",
        accessor: "site",
        isNumeric: false,
        id: 4,
        sortByName: "site.siteName",
        sortDirection: "asc",
        active: true,
        searchOnName: "site.id",
        lookupName: "site.siteName",
        translationKey: "site",
        filterId: FILTER_SITES,
        columnId: COLUMN_SITE,
        settingDataName: "site"
    },
    {
        heading: "Preset",
        accessor: "preset",
        isNumeric: false,
        id: 5,
        // sortDirection: "asc",
        active: true,
        translationKey: "preset",
    },
    {
        heading: "Queue",
        accessor: "queue",
        isNumeric: true,
        id: 6,
        active: true,
        translationKey: "queue",
        columnId: COLUMN_QUEUE,
    }
    // Will be enabled in future
    // {
    //     heading: "Readers",
    //     accessor: "readers",
    //     isNumeric: true,
    //     id: 7,
    //     active: true,
    //     translationKey: "readers",
    //     columnId: COLUMN_READERS_COUNT,
    // },
];


export default ControllerColumns;
